import { BoothBlogPostDisplay } from "../../../shared/interfaces";

class BlogPostOverlay {
  domElement: HTMLElement;
  imageElement: HTMLImageElement;
  descriptionElement: HTMLParagraphElement;
  linkElement: HTMLAnchorElement;

  constructor() {
  }

  init() {
    this.domElement = document.getElementById('blogPostOverlay');
    this.imageElement = this.domElement.querySelector('img');
    this.descriptionElement = this.domElement.querySelector('p');
    this.linkElement = this.domElement.querySelector('a');
    this.domElement.querySelector('button').addEventListener('click', () => this.hide())
  }

  show(post: BoothBlogPostDisplay) {
    this.domElement.style.display = 'flex';
    this.imageElement.src = post.imageUrl;
    this.descriptionElement.innerText = post.description;
    this.linkElement.href = post.blogPostUrl;
  }

  hide() {
    this.domElement.style.display = 'none';
    this.imageElement.src = '';
    this.descriptionElement.innerText = '';
    this.linkElement.href = '';
  }
}

export default new BlogPostOverlay();
